import { render } from "./ProfileLanguage.vue?vue&type=template&id=2dd2b7dc&scoped=true"
import script from "./ProfileLanguage.vue?vue&type=script&lang=js"
export * from "./ProfileLanguage.vue?vue&type=script&lang=js"

import "./ProfileLanguage.vue?vue&type=style&index=0&id=2dd2b7dc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd2b7dc"]])

export default __exports__